import { render } from "./TypeChoice.vue?vue&type=template&id=d376d47a&ts=true"
import script from "./TypeChoice.vue?vue&type=script&lang=ts"
export * from "./TypeChoice.vue?vue&type=script&lang=ts"

import "./TypeChoice.vue?vue&type=style&index=0&id=d376d47a&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__